import { render, staticRenderFns } from "./model_tip.vue?vue&type=template&id=34f10578&scoped=true"
import script from "./model_tip.vue?vue&type=script&lang=js"
export * from "./model_tip.vue?vue&type=script&lang=js"
import style0 from "./model_tip.vue?vue&type=style&index=0&id=34f10578&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f10578",
  null
  
)

export default component.exports